import React, {Component} from "react";
import Logo from "./Logo";

class NavBar extends Component {
    render() {
        return (
            <div className="navbar navbar-expand-sm fixed-top navbar-dark bg-primary">
                <div className="container">
                    <Logo width={"40px"} height={"40px"} marginRight={"10px"} shadow={false}/>
                    <a className="navbar-brand text-light" href="/">RigChecks</a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar"
                            aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>
                    <div className="collapse navbar-collapse text-center text-light" id="navbar">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="/features">Features</a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="/pricing">Pricing</a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="/contact">Contact</a>
                            </li>

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#"
                                   id="download">Download<span className="caret"/></a>
                                <div className="dropdown-menu" aria-labelledby="download">
                                    <a className="dropdown-item" target="_blank" rel="noopener noreferrer"
                                       href="https://play.google.com/store/apps/details?id=com.rigchecks.app">
                                        <i className="fa fa-android text-success"></i> Android
                                    </a>
                                    <a className="dropdown-item disabled">
                                        <i className="fa fa-apple text-muted"></i> iOS (Coming soon)
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <form className="form-inline my-2 my-lg-0" action="https://dashboard.rigchecksems.com/login">
                            <button className="btn btn-secondary my-2 my-sm-0" type="submit">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/component/NavBar.js